import { useDistributionStore } from "../store/useDistributionStore";
import { useDistributionNavigationStore } from "../store/useDistributionNavigationStore";
import ListsService from "@/services/ListsService";
import { ref } from "vue";
import LlSecondaryButton from "@/components/LlSecondaryButton.vue";
export default {
  components: {
    LlSecondaryButton
  },
  setup() {
    const distributionNavigationStore = useDistributionNavigationStore();
    const distributionStore = useDistributionStore();
    const distributionStatuses = ref([]);
    const selectedStatus = ref("");
    distributionStatuses.value = new ListsService().distributionStatuses;
    distributionStatuses.value[0] = {
      id: "all",
      label: "All"
    };
    selectedStatus.value = distributionStore.distributionParms.statusId;
    const filterByDistributionStatus = () => {
      distributionStore.changeDistributionStatus(selectedStatus.value);
      distributionNavigationStore.toggleDistributionStatusModal(false);
    };
    function closeModal() {
      distributionNavigationStore.toggleDistributionStatusModal(false);
      selectedStatus.value = distributionStore.distributionParms.status;
    }
    return {
      closeModal,
      selectedStatus,
      distributionStore,
      distributionStatuses,
      filterByDistributionStatus,
      distributionNavigationStore
    };
  }
};